'use strict';

wbApp.controller('MainCtrl', ['$scope', 'breadcrumbs',
function ($scope, breadcrumbs) {
    $scope.breadcrumbs = breadcrumbs;

    $scope.onRefreshButtonClick = function () {
        $scope.$broadcast('refreshData', null);
    }
}]);